import { TELUGU_FEATURE_FILMS, RUDRA_PREVIEW_URL } from '../data/portfolioData';

export default function TeluguMoviesSection() {
  return (
    <section
      id="feature-films"
      className="bg-[#050505] py-20 sm:py-28 border-t border-white/[0.08] w-full"
    >
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 pb-10 border-b border-white/[0.08]">
          <div className="max-w-2xl">
            <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-[#E50914] mb-2">
              ● Theatrical Motion Pictures &nbsp;·&nbsp; Hybrid Live-Action + AI VFX
            </p>
            <h2 className="text-white font-normal tracking-[-0.03em] leading-[1.05] text-[clamp(1.85rem,3.4vw,3.25rem)]">
              Feature Film VFX Credits
            </h2>
            <p className="text-[#767d88] text-sm sm:text-[15px] mt-2.5 leading-relaxed">
              Our Hybrid VFX pipeline powers Telugu theatrical releases — combining real
              cinema camera plates with AI environment extension, relighting, and 2K/4K
              ProRes 4444 compositing.
            </p>
          </div>
          <span className="text-[12px] text-[#767d88] font-mono">
            2K / 4K ProRes 4444 &nbsp;·&nbsp; Rec.709 / ACES
          </span>
        </div>

        {/* 3 Feature Film Poster Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-10">
          {TELUGU_FEATURE_FILMS.map((movie) => (
            <article key={movie.slug} className="group flex flex-col">
              <div className="relative aspect-[16/10] rounded-lg overflow-hidden bg-[#111113] border border-white/[0.08]">
                <img
                  src={movie.posterUrl}
                  alt={`${movie.title} (${movie.star})`}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded bg-black/70 backdrop-blur-md text-[11px] text-white/90">
                  {movie.year} Feature Film
                </div>
              </div>

              <div className="pt-4">
                <div className="flex items-baseline justify-between gap-2">
                  <h3 className="text-[20px] font-medium tracking-[-0.02em] text-white">
                    {movie.title}
                  </h3>
                  <span className="text-[12px] text-white/60">{movie.star}</span>
                </div>
                <p className="text-[13px] text-[#767d88] mt-1">
                  Directed by {movie.director} &nbsp;·&nbsp; {movie.role}
                </p>
                <p className="text-[13px] text-white/50 mt-2.5 leading-relaxed">
                  {movie.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* RUDRA Flagship Feature Preview */}
        <div className="mt-16 pt-12 border-t border-white/[0.08] grid grid-cols-1 lg:grid-cols-[1.3fr_1fr] gap-8 lg:gap-12 items-center">
          <div className="aspect-video rounded-lg overflow-hidden bg-black border border-white/[0.08]">
            <video
              src={RUDRA_PREVIEW_URL}
              autoPlay
              muted
              loop
              playsInline
              controls
              preload="metadata"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-[#E50914] mb-2">
              ● MotionX In-House Feature Film &nbsp;·&nbsp; 90+ Minutes
            </p>
            <h3 className="text-white font-normal tracking-[-0.03em] text-3xl sm:text-4xl">
              Rudra
            </h3>
            <p className="text-[#767d88] text-sm sm:text-[15px] leading-relaxed mt-3">
              Shot with real actors, real cameras, and real performances — then transformed
              frame-by-frame through our Hybrid AI VFX pipeline. Theatrical scale delivered at
              a fraction of conventional budgets with full copyright protection.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
